module.exports = __webpack_public_path__ + "img/head.928d4b95.png";